var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.364 40.785V4.909a1 1 0 00-1-1h-4.83a1 1 0 00-1 1v35.876h-4.468V12.796a1 1 0 00-1-1h-4.831a1 1 0 00-1 1v27.989h-4.47V1a1 1 0 00-1-1h-4.83a1 1 0 00-1 1v39.785h-4.469V27.462a1 1 0 00-1-1h-4.83a1 1 0 00-1 1v13.323H.418c-.23 0-.419.253-.419.562 0 .31.188.562.419.562H49.58c.23 0 .419-.253.419-.562 0-.312-.186-.562-.419-.562h-4.217z",
    fill: "#3A92E5",
    fillRule: "nonzero"
  })));
}
export default SvgBar;